import React, { useEffect, useState } from "react";
import axios from "axios";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";

const OTPScreen = ({ formValues, rncode, onClose = () => {} }) => {
  const [otpError, setOtpError] = useState("");
  const initialValues = {
    otp: ["", "", "", ""],
  };

  const validationSchema = Yup.object({
    otp: Yup.array()
      .of(
        Yup.string()
          .length(1, "Each field must contain one digit")
          .matches(/^\d$/, "Only digits are allowed")
      )
      .test(
        "length",
        "OTP must be 4 digits long",
        (value) => value.filter(Boolean).length === 4
      ),
  });

  const verifyOTP = async (values) => {
    const url =
      "https://service.infohubinnovations.com/contactus/api/contact/us/verify-otp";

    try {
      const otpCode = values.otp.join("");
      const params = {
        email: formValues.email,
        otp: otpCode,
        rnCode: rncode,
      };

      const response = await axios.post(url, {}, { params });
      if (response.status === 200) {
        submitForm(formValues, rncode);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setOtpError("Wrong OTP. Please try again.");
      } else {
        console.error("Error verifying OTP:", error);
      }
    }
  };

  const submitForm = async (formValues, rncode) => {
    const url =
      "https://service.infohubinnovations.com/contactus/api/contact/us/submit-form";

    try {
      const params = {
        email: formValues.email,
        name: formValues.name,
        phone: formValues.contactNumber,
        message: formValues.message,
        rnCode: rncode,
        projectCode: "tw_XWWdIQLZ",
      };

      const response = await axios.post(url, {}, { params });
      if (response.status === 200) {
        onClose();
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };

  const handleInputChange = (value, index, formik) => {
    if (/^\d*$/.test(value)) {
      const otpArray = [...formik.values.otp];
      otpArray[index] = value.slice(-1);
      formik.setFieldValue("otp", otpArray);

      if (value && index < otpArray.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  return (
    <div className="flex items-center justify-center">
      <div
        className="bg-white p-8 w-full"
        style={{ maxWidth: "480px", minWidth: "320px", width: "90%" }}
      >
        <h2 className="text-2xl font-semibold mb-4 text-center">Verify OTP</h2>
        <p className="mb-6 text-gray-600 text-center">
          An authentication code has been sent to your email{" "}
          <span className="font-semibold">
            {formValues.email?.substr(0, 3) +
              "***" +
              formValues.email?.substr(-6) || "*****"}
          </span>
          . If you do not receive the message in your inbox, please check your
          spam or junk box.
        </p>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={verifyOTP}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {(formik) => (
            <Form>
              <div className="flex justify-center gap-3 mb-6">
                {formik.values.otp.map((digit, index) => (
                  <Field name={`otp[${index}]`} key={index}>
                    {({ field }) => (
                      <input
                        {...field}
                        id={`otp-input-${index}`}
                        type="text"
                        maxLength="1"
                        value={formik.values.otp[index]}
                        onChange={(e) =>
                          handleInputChange(e.target.value, index, formik)
                        }
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className={`border rounded-lg w-16 h-16 text-center text-2xl font-semibold focus:ring-2 focus:ring-blue-500 focus:outline-none ${
                          formik.errors.otp && formik.touched.otp
                            ? "border-red-500"
                            : ""
                        }`}
                      />
                    )}
                  </Field>
                ))}
              </div>
              {formik.errors.otp && formik.touched.otp && (
                <p className="text-red-500 text-sm text-center mb-4">
                  {formik.errors.otp}
                </p>
              )}
              {otpError && (
                <p className="text-red-500 text-sm text-center mb-4">
                  {otpError}
                </p>
              )}
              <div className="flex items-center justify-center w-full">
                <button
                  type="submit"
                  className={`bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 text-lg font-medium block w-[75%] ${
                    formik.isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                  } self-center`}
                  disabled={formik.isSubmitting}
                >
                  Verify OTP
                </button>
              </div>
            </Form>
          )}
        </Formik>

        <button
          onClick={() => onClose("otp")}
          className="block mx-auto text-red-500 hover:text-red-600 text-sm mt-4"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default OTPScreen;
